<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 头部 -->
		<div class="titleView">
			<el-row style="padding-left:10px;">
				<el-col :span="4">采购批次号: {{detailData.procure_no}}</el-col>
				<el-col :span="4" v-if="detailData.add_info">采购人: {{detailData.add_info.add_user_info.user_name}}</el-col>
				<el-col :span="4" v-if="detailData.add_info">申请日期: {{sqDate}}</el-col>
				<el-col :span="4">
					<span v-if="detailData.state == 1">采购状态:采购中</span>
					<span v-if="detailData.state == 3">采购状态:采购完成</span>
					<span v-if="detailData.state == 4">采购状态:采购取消</span>
				</el-col>
				<el-col :span="8" style="text-align: right;">
					<el-button @click="handleUploadClick(2)" size="small">下载报货单</el-button>
					<el-button @click="handleUploadClick(1)" size="small">下载验货单</el-button>
					<!-- <el-button @click="handleRecordClick">门店出库记录</el-button> -->
					<el-button @click="handleUploadRecordClick" size="small">下载分拨单</el-button>
					<el-button  size="small" @click="handleDeliveryClick">下载配送单</el-button>
					<el-button type="warning" @click="handleBackClick" style="margin-right: 40px;" size="small">返回</el-button>
				</el-col>
			</el-row>
			<el-row style="padding-left:10px;">
				<el-col :span="3" v-if="detailData.otherInfo">产品数量: {{detailData.otherInfo.goodsTotal}}</el-col>
				<el-col :span="3" v-if="detailData.otherInfo">采购数量: {{detailData.otherInfo.procureTotal}}</el-col>
				<el-col :span="3" v-if="detailData.otherInfo">实收数量: {{detailData.otherInfo.paidTotal}}</el-col>
				<el-col :span="3" v-if="detailData.otherInfo">赠品数量: {{detailData.otherInfo.givingTotal}}</el-col>
				<el-col :span="3" v-if="detailData.otherInfo">总计数量: {{detailData.otherInfo.countTotal}}</el-col>
				<el-col :span="3" v-if="detailData.otherInfo">总销售价: {{detailData.otherInfo.priceTotal}}</el-col>
			</el-row>
		</div>
		<!-- tab切换 -->
		<div class="tabs">
			<el-button @click="handleTabClick(-1)" :type="tabIndex == -1?'warning':''" size="small">全部</el-button>
			<el-button v-for="(item,index) in storeTab" :key="index" @click="handleTabClick(index)" :type="tabIndex == index?'warning':''" size="small">{{item}}</el-button>
		</div>
		<!-- 滚动位置 -->
		<div class="scrollView" style="overflow-y: scroll;" ref="scrollView">
			<!-- 全部商品 -->
			<div id="page-1">
				<!-- 商品类 -->
				<div class="shopClass" v-if="shops.length > 0">
					<div class="comH2" @click="showShop = !showShop">
						<div>商品类</div>
						<i class="el-icon-caret-bottom" v-if="showShop"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="showShop">
						<el-table ref="allShopTable" :data="shops" tooltip-effect="dark" @selection-change="handleAllShopChange" size="small">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="goods.title" label="商品名称" />
							<el-table-column :key="2" width="50">
								<template slot-scope="scope">
									<el-tag effect="dark" v-if="scope.row.add_type == 2" size="small" type="success">采</el-tag>
								</template>
							</el-table-column>
							<el-table-column :key="3" prop="goods.brand" label="品牌" align="center" />
							<el-table-column :key="4" label="供应商" prop="suppliers" width="120">
								<template slot-scope="scope">
									<el-select v-model="scope.row.supplier_id" placeholder="请选择" @change="selectDChange(scope.row)" filterable size="small">
										<el-option v-for="item in suppliers" :key="item._id" :label="item.basic_info.name" :value="item._id" />
									</el-select>
								</template>
							</el-table-column>
							<el-table-column :key="5" prop="goods.sku_value" label="规格" align="center" width="120" />
							<el-table-column :key="6" prop="goods.unit" label="单位" align="center" />
							<el-table-column :key="7" prop="goods_count" label="采购数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.goods_count == 0?'--':scope.row.goods_count}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="8" prop="count" label="实收数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data == null?'0':scope.row.validation_data.paid_count}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="9" prop="count" label="赠品数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data == null?'0':scope.row.validation_data.giving_count}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="10" prop="goods.pprice" label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data == null?'0':scope.row.validation_data.cost_price}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="procure_goods_remark" label="备注" align="center" width="140" size="small">
								<template slot-scope="scope">
									<template v-if="scope.row.add_type == 2 && scope.row.procure_goods_state < 3">
										<el-input placeholder="请输入备注" v-model="scope.row.validation_data.remarks" @change="remarkChange(scope.row)" size="small"/>
									</template>
									<template v-if="scope.row.add_type == 2 && scope.row.procure_goods_state >= 3">
										<div v-if="scope.row.validation_data == null">--</div>
										<div v-else>
											<span v-if="scope.row.validation_data.remarks == ''">--</span>
											<span v-if="scope.row.validation_data.remarks != ''">{{scope.row.validation_data.remarks}}</span>
										</div>
									</template>
								</template>
							</el-table-column>
							<el-table-column :key="111" prop="procure_goods_remark" label="申请单备注" align="center" width="140" size="small">
								<template slot-scope="scope">
									<div v-if="scope.row.procurez_request_list">
										<div v-for="(re,reIndex) in scope.row.procurez_request_list" :key="reIndex">
											<span style="color:red;">{{$public.getShopNameById(re.company_info.shop_id)}}:</span>
											<span>{{re.remarks}}</span>
										</div>
										<!-- <el-popover
										placement="top"
										title="申请单备注"
										width="200"
										trigger="hover">
											<img slot="reference" style="width:18px;height: 18px;vertical-align: sub;cursor: pointer;" src="../../../assets/img/icon_eye.jpg"/>
											<div>
												<div v-if="scope.row.procurez_request_list">
													<div style="display: flex;" v-for="(re,reIndex) in scope.row.procurez_request_list" :key="reIndex">
														<div style="width:45px">{{$public.getShopNameById(re.company_info.shop_id)}}：</div>
														<div style="width:150px;">{{re.remarks}}</div>
													</div>
												</div>
											</div>
										</el-popover> -->
									</div>
									<div v-else>无</div>
								</template>
							</el-table-column>
							<el-table-column :key="12" prop="procure_goods_remark" label="有效期" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validation_data.overdue_time_list == null">--</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length > 1">多效期</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length == 1">{{scope.row.validation_data.overdue_time_list[0].overdue_time == ''?'--':FormatDate(scope.row.validation_data.overdue_time_list[0].overdue_time)}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="13" label="状态" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.procure_goods_state == -3">异常</span>
									<span v-if="scope.row.procure_goods_state == -2">无货</span>
									<span v-if="scope.row.procure_goods_state == 1">未验货</span>
									<span v-if="scope.row.procure_goods_state == 2">部分验货</span>
									<span v-if="scope.row.procure_goods_state == 3">未分拨</span>
									<span v-if="scope.row.procure_goods_state == 4">部分分拨</span>
									<span v-if="scope.row.procure_goods_state == 5">未打码</span>
									<span v-if="scope.row.procure_goods_state == 6">部分打码</span>
									<span v-if="scope.row.procure_goods_state == 7">全部打码</span>
									<span v-if="scope.row.procure_goods_state == 8">分拨出库</span>
									<span v-if="scope.row.procure_goods_state == 9">门店部分收货</span>
									<span v-if="scope.row.procure_goods_state == 10">门店全部收货</span>
								</template>
							</el-table-column>
							<el-table-column :key="15" label="异常" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validation_data.abnormal_count == 0">--</span>
									<el-popover v-else placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.validation_data.abnormal_info.leakage_count+' 破损:'+scope.row.validation_data.abnormal_info.broken_count+' 过期:'+scope.row.validation_data.abnormal_info.overdue_count+' 调换:'+scope.row.validation_data.abnormal_info.switch_count+' 无货:'+scope.row.validation_data.abnormal_info.no_count">
										<div slot="reference">异常{{scope.row.validation_data.abnormal_count}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column :key="14" label="操作" align="center" width="140">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state==1" @click="handleInspectionClick(scope.row)">验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state==1" @click="handleCopyClick(scope.row)">复制</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state == 3 || scope.row.procure_goods_state == 2" @click="handleResetGoodsClick(scope.row)">重新验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state == 3" @click="handleAssignClick(scope.row)">分拨</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state > 5" @click="toggleAllShop(scope.row)">查看条码</el-button>
									<el-button type="text" size="small" @click="handleUpdatePrice(scope.row)">修改成本价</el-button>
								</template>
							</el-table-column>
							<!-- 查看条码 -->
							<el-table-column type="expand" width="1">
								<template slot-scope="scope" v-if="scope.row.procure_goods_state > 5">
									<div class="codeView">
										<div v-for="(shopItem,shopIndex) in scope.row.distributions_list" class="shopView" :key="'shopItem'+shopIndex">
											<template v-if="shopItem.code_count != 0">
												<div class="shopViewName">{{shopItem.company_info.shop_name}}</div>
												<div class="validView" v-for="(overItem,overIndex) in shopItem.distribution_datas_list" :key="'overItem'+overIndex">
													<template v-if="overItem.code_count != 0">
														<div class="validViewName">有效期:{{FormatDate(overItem.overdue_time)}} 条码数量:{{overItem.code_count}}</div>
														<template v-for="(codeItem,codeIndex) in overItem.goods_code_list">
															<div v-if="codeItem.goods_state == 4" class="codes1" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)" :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
															<div v-else class="codes" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)"  :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
														
														</template>
													</template>
												</div>
											</template>
										</div>
									</div>
								</template>
							</el-table-column>
						</el-table>
						<div class="allNum">
							<div>共{{shopCount}}件</div>
							<div>成本价合计：{{shopPrice.toFixed(2)}}</div>
						</div>
					</div>
				</div>
				<!-- 医疗类 -->
				<div class="shopClass" v-if="drugs.length > 0">
					<div class="comH2" @click="showDrug = !showDrug">
						<div>医疗类</div>
						<i class="el-icon-caret-bottom" v-if="showDrug"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="showDrug">
						<el-table ref="allDrugTable" :data="drugs" tooltip-effect="dark" @selection-change="handleAllDrugChange" size="small">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="goods.title" label="商品名称" />
							<el-table-column :key="2" width="50">
								<template slot-scope="scope">
									<el-tag effect="dark" v-if="scope.row.add_type == 2" size="small" type="success">采</el-tag>
								</template>
							</el-table-column>
							<el-table-column :key="3" prop="goods.brand" label="品牌" align="center" />
							<el-table-column :key="4" label="供应商" width="120">
								<template slot-scope="scope">
									<el-select v-model="scope.row.supplier_id" placeholder="请选择" @change="selectDChange(scope.row)" filterable size="small">
										<el-option v-for="item in suppliers" :key="item._id" :label="item.basic_info.name" :value="item._id" />
									</el-select>
								</template>
							</el-table-column>
							<el-table-column :key="5" prop="goods.sku_value" label="规格" align="center" width="120" />
							<el-table-column :key="6" prop="goods.unit" label="单位" align="center" />
							<el-table-column :key="7" prop="goods_count" label="采购数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.goods_count == 0?'--':scope.row.goods_count}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="8" label="实收数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data == null?'0':scope.row.validation_data.paid_count}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="9" label="赠品数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data == null?'0':scope.row.validation_data.giving_count}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="10" prop="goods.pprice" label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data == null?'0':scope.row.validation_data.cost_price}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="procure_goods_remark" label="备注" align="center" width="140" size="small">
								<template slot-scope="scope">
									<template v-if="scope.row.add_type == 2 && scope.row.procure_goods_state < 3">
										<el-input placeholder="请输入备注" v-model="scope.row.validation_data.remarks" @change="remarkChange(scope.row)" size="small"/>
									</template>
									<template v-if="scope.row.add_type == 2 && scope.row.procure_goods_state >= 3">
										<div v-if="scope.row.validation_data == null">--</div>
										<div v-else>
											<span v-if="scope.row.validation_data.remarks == ''">--</span>
											<span v-if="scope.row.validation_data.remarks != ''">{{scope.row.validation_data.remarks}}</span>
										</div>
									</template>
								</template>
							</el-table-column>
							<el-table-column :key="111" prop="procure_goods_remark" label="申请单备注" align="center" width="140" size="small">
								<template slot-scope="scope">
									<div v-if="scope.row.procurez_request_list">
										<div v-for="(re,reIndex) in scope.row.procurez_request_list" :key="reIndex">
											<span style="color:red;">{{$public.getShopNameById(re.company_info.shop_id)}}:</span>
											<span>{{re.remarks}}</span>
										</div>
										<!-- <el-popover
										placement="top"
										title="申请单备注"
										width="200"
										trigger="hover">
											<img slot="reference" style="width:18px;height: 18px;vertical-align: sub;cursor: pointer;" src="../../../assets/img/icon_eye.jpg"/>
											<div>
												<div v-if="scope.row.procurez_request_list">
													<div style="display: flex;" v-for="(re,reIndex) in scope.row.procurez_request_list" :key="reIndex">
														<div style="width:45px">{{$public.getShopNameById(re.company_info.shop_id)}}：</div>
														<div style="width:150px;">{{re.remarks}}</div>
													</div>
												</div>
											</div>
										</el-popover> -->
									</div>
									<div v-else>无</div>
								</template>
							</el-table-column>
							<el-table-column :key="12" label="有效期" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validation_data.overdue_time_list == null">--</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length > 1">多效期</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length == 1">{{scope.row.validation_data.overdue_time_list[0].overdue_time == ''?'--':FormatDate(scope.row.validation_data.overdue_time_list[0].overdue_time)}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="13" label="状态" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.procure_goods_state == -3">异常</span>
									<span v-if="scope.row.procure_goods_state == -2">无货</span>
									<span v-if="scope.row.procure_goods_state == 1">未验货</span>
									<span v-if="scope.row.procure_goods_state == 2">部分验货</span>
									<span v-if="scope.row.procure_goods_state == 3">未分拨</span>
									<span v-if="scope.row.procure_goods_state == 4">部分分拨</span>
									<span v-if="scope.row.procure_goods_state == 5">未打码</span>
									<span v-if="scope.row.procure_goods_state == 6">部分打码</span>
									<span v-if="scope.row.procure_goods_state == 7">全部打码</span>
									<span v-if="scope.row.procure_goods_state == 8">分拨出库</span>
									<span v-if="scope.row.procure_goods_state == 9">门店部分收货</span>
									<span v-if="scope.row.procure_goods_state == 10">门店全部收货</span>
								</template>
							</el-table-column>
							<el-table-column :key="15" label="异常" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validation_data.abnormal_count == 0">--</span>
									<el-popover v-else placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.validation_data.abnormal_info.leakage_count+' 破损:'+scope.row.validation_data.abnormal_info.broken_count+' 过期:'+scope.row.validation_data.abnormal_info.overdue_count+' 调换:'+scope.row.validation_data.abnormal_info.switch_count+' 无货:'+scope.row.validation_data.abnormal_info.no_count">
										<div slot="reference">异常{{scope.row.validation_data.abnormal_count}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column :key="14" label="操作" align="center" width="140">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
									
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state==1" @click="handleInspectionClick(scope.row)">验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state==1" @click="handleCopyClick(scope.row)">复制</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state == 3 || scope.row.procure_goods_state == 2" @click="handleResetGoodsClick(scope.row)">重新验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state == 3" @click="handleAssignClick(scope.row)">分拨</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state > 5" @click="toggleAllDrug(scope.row)">查看条码</el-button>
									<el-button type="text" size="small" @click="handleUpdatePrice(scope.row)">修改成本价</el-button>
								</template>
							</el-table-column>
							<!-- 查看条码 -->
							<el-table-column type="expand" width="1">
								<template slot-scope="scope" v-if="scope.row.procure_goods_state > 5">
									<div class="codeView">
										<div v-for="(shopItem,shopIndex) in scope.row.distributions_list" class="shopView" :key="'shopItem'+shopIndex">
											<template v-if="shopItem.code_count != 0">
												<div class="shopViewName">{{shopItem.company_info.shop_name}}</div>
												<div class="validView" v-for="(overItem,overIndex) in shopItem.distribution_datas_list" :key="'overItem'+overIndex">
													<template v-if="overItem.code_count != 0">
														<div class="validViewName">有效期:{{FormatDate(overItem.overdue_time)}} 条码数量:{{overItem.code_count}}</div>
														<template v-for="(codeItem,codeIndex) in overItem.goods_code_list">
															<div v-if="codeItem.goods_state == 4" class="codes1" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)" :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
															<div v-else class="codes" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)" :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
														</template>
													</template>
												</div>
											</template>
										</div>
									</div>
								</template>
							</el-table-column>
						</el-table>
						<div class="allNum">
							<div>共{{drugCount}}件</div>
							<div>成本价合计：{{drugPrice.toFixed(2)}}</div>
						</div>
					</div>
				</div>
				<!-- 耗材类 -->
				<div class="shopClass" v-if="haocais.length > 0">
					<div class="comH2" @click="showHaocai = !showHaocai">
						<div>耗材类</div>
						<i class="el-icon-caret-bottom" v-if="showHaocai"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="showHaocai">
						<el-table ref="allHaocaiTable" :data="haocais" tooltip-effect="dark" @selection-change="handleAllHaocaiChange" size="small">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="goods.title" label="商品名称" />
							<el-table-column :key="2" width="50">
								<template slot-scope="scope">
									<el-tag effect="dark" v-if="scope.row.add_type == 2" size="small" type="success">采</el-tag>
								</template>
							</el-table-column>
							<el-table-column :key="3" prop="goods.brand" label="品牌" align="center">
								<template>
									<span>--</span>
								</template>
							</el-table-column>
							<el-table-column :key="4" label="供应商" width="120">
								<template slot-scope="scope">
									<el-select v-model="scope.row.supplier_id" placeholder="请选择" @change="selectDChange(scope.row)" filterable size="small">
										<el-option v-for="item in suppliers" :key="item._id" :label="item.basic_info.name" :value="item._id" />
									</el-select>
								</template>
							</el-table-column>
							<el-table-column :key="5" prop="goods.sku_value" label="规格" align="center" width="120">
								<template>
									<span>--</span>
								</template>
							</el-table-column>
							<el-table-column :key="6" prop="goods.unit" label="单位" align="center" />
							<el-table-column :key="7" prop="goods_count" label="采购数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.goods_count == 0?'--':scope.row.goods_count}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="8" label="实收数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data == null?'0':scope.row.validation_data.paid_count}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="9" label="赠品数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data == null?'0':scope.row.validation_data.giving_count}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="10" prop="goods.pprice" label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validation_data == null?'0':scope.row.validation_data.cost_price}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="procure_goods_remark" label="备注" align="center" width="140" size="small">
								<template slot-scope="scope">
									<template v-if="scope.row.add_type == 2 && scope.row.procure_goods_state < 3">
										<el-input placeholder="请输入备注" v-model="scope.row.validation_data.remarks" @change="remarkChange(scope.row)" size="small"/>
									</template>
									<template v-if="scope.row.add_type == 2 && scope.row.procure_goods_state >= 3">
										<div v-if="scope.row.validation_data == null">--</div>
										<div v-else>
											<span v-if="scope.row.validation_data.remarks == ''">--</span>
											<span v-if="scope.row.validation_data.remarks != ''">{{scope.row.validation_data.remarks}}</span>
										</div>
									</template>
								</template>
							</el-table-column>
							<el-table-column :key="111" prop="procure_goods_remark" label="申请单备注" align="center" width="140" size="small">
								<template slot-scope="scope">
									<div v-if="scope.row.procurez_request_list">
										<div v-for="(re,reIndex) in scope.row.procurez_request_list" :key="reIndex">
											<span style="color:red;">{{$public.getShopNameById(re.company_info.shop_id)}}:</span>
											<span>{{re.remarks}}</span>
										</div>
										<!-- <el-popover
										placement="top"
										title="申请单备注"
										width="200"
										trigger="hover">
											<img slot="reference" style="width:18px;height: 18px;vertical-align: sub;cursor: pointer;" src="../../../assets/img/icon_eye.jpg"/>
											<div>
												<div v-if="scope.row.procurez_request_list">
													<div style="display: flex;" v-for="(re,reIndex) in scope.row.procurez_request_list" :key="reIndex">
														<div style="width:45px">{{$public.getShopNameById(re.company_info.shop_id)}}：</div>
														<div style="width:150px;">{{re.remarks}}</div>
													</div>
												</div>
											</div>
										</el-popover> -->
									</div>
									<div v-else>无</div>
								</template>
							</el-table-column>
							<el-table-column :key="12" label="有效期" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validation_data.overdue_time_list == null">--</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length > 1">多效期</span>
									<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length == 1">{{scope.row.validation_data.overdue_time_list[0].overdue_time == ''?'--':FormatDate(scope.row.validation_data.overdue_time_list[0].overdue_time)}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="13" label="状态" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.procure_goods_state == -3">异常</span>
									<span v-if="scope.row.procure_goods_state == -2">无货</span>
									<span v-if="scope.row.procure_goods_state == 1">未验货</span>
									<span v-if="scope.row.procure_goods_state == 2">部分验货</span>
									<span v-if="scope.row.procure_goods_state == 3">未分拨</span>
									<span v-if="scope.row.procure_goods_state == 4">部分分拨</span>
									<span v-if="scope.row.procure_goods_state == 5">未打码</span>
									<span v-if="scope.row.procure_goods_state == 6">部分打码</span>
									<span v-if="scope.row.procure_goods_state == 7">全部打码</span>
									<span v-if="scope.row.procure_goods_state == 8">分拨出库</span>
									<span v-if="scope.row.procure_goods_state == 9">门店部分收货</span>
									<span v-if="scope.row.procure_goods_state == 10">门店全部收货</span>
								</template>
							</el-table-column>
							<el-table-column :key="15" label="异常" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validation_data.abnormal_count == 0">--</span>
									<el-popover v-else placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.validation_data.abnormal_info.leakage_count+' 破损:'+scope.row.validation_data.abnormal_info.broken_count+' 过期:'+scope.row.validation_data.abnormal_info.overdue_count+' 调换:'+scope.row.validation_data.abnormal_info.switch_count+' 无货:'+scope.row.validation_data.abnormal_info.no_count">
										<div slot="reference">异常{{scope.row.validation_data.abnormal_count}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column :key="14" label="操作" align="center" width="140">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
									
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state==1" @click="handleInspectionClick(scope.row)">验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state==1" @click="handleCopyClick(scope.row)">复制</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state == 3 || scope.row.procure_goods_state == 2" @click="handleResetGoodsClick(scope.row)">重新验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state == 3" @click="handleAssignClick(scope.row)">分拨</el-button>
									<el-button type="text" size="small" v-if="scope.row.procure_goods_state > 5" @click="toggleAllHaocai(scope.row)">查看条码</el-button>
									<el-button type="text" size="small" @click="handleUpdatePrice(scope.row)">修改成本价</el-button>
								</template>
							</el-table-column>
							<!-- 查看条码 -->
							<el-table-column type="expand" width="1">
								<template slot-scope="scope" v-if="scope.row.procure_goods_state > 5">
									<div class="codeView">
										<div v-for="(shopItem,shopIndex) in scope.row.distributions_list" class="shopView" :key="'shopItem'+shopIndex">
											<template v-if="shopItem.code_count != 0">
												<div class="shopViewName">{{shopItem.company_info.shop_name}}</div>
												<div class="validView" v-for="(overItem,overIndex) in shopItem.distribution_datas_list" :key="'overItem'+overIndex">
													<template v-if="overItem.code_count != 0">
														<div class="validViewName">有效期:{{FormatDate(overItem.overdue_time)}} 条码数量:{{overItem.code_count}}</div>
														<template v-for="(codeItem,codeIndex) in overItem.goods_code_list">
															<div v-if="codeItem.goods_state == 4" class="codes1" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)" :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
															<div v-else class="codes" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)" :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
														</template>
													</template>
												</div>
											</template>
										</div>
									</div>
								</template>
							</el-table-column>
						</el-table>
						<div class="allNum">
							<div>共{{haocaiCount}}件</div>
							<div>成本价合计：{{haocaiPrice.toFixed(2)}}</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 其他门店商品 -->
			<template v-for="(item,index) in stores">
				<div :id="'page'+index" :key="index">
					<div class="storeName">
						<div @click="handleStoreClick(index)">
							<span>采购门店:{{item.companyInfo.shop_name}}</span>
							<i class="el-icon-caret-bottom" v-if="item.isShow" style="color: #1890FF;"></i>
							<i class="el-icon-caret-top" v-else style="color: #1890FF;"></i>
							<span v-for="(storeItem,storeIndex) in item.procureRequestNo" :key="storeIndex"> {{storeItem}}</span>
						</div>
						<div v-if="item.isShow">
							<el-button size="small" type="warning" style="margin-right: 20px;" @click="handlefenbochukuClick(index)">门店出库</el-button>
						</div>
					</div>
					<!-- 商品类 -->
					<div class="shopClass" v-if="item.procureGoodsList.shop.shops.length > 0 && item.isShow" >
						<div class="comH2" @click="handleStoreZLClick(index,1)">
							<div>商品类</div>
							<i class="el-icon-caret-bottom" v-if="item.procureGoodsList.shop.isShow"></i>
							<i class="el-icon-caret-top" v-else></i>
						</div>
						<div class="tableWarp" v-if="item.procureGoodsList.shop.isShow">
							<el-table :ref="'shopTable'+index" :data="item.procureGoodsList.shop.shops" tooltip-effect="dark" @selection-change="handleSelectShop(arguments[0],index)" size="small">
								<el-table-column type="selection" width="55"/>
								<el-table-column :key="1" prop="goods.title" label="商品名称" />
								<el-table-column :key="2" width="50">
									<template slot-scope="scope">
										<el-tag effect="dark" v-if="scope.row.add_type == 2" size="small" type="success">采</el-tag>
									</template>
								</el-table-column>
								<el-table-column :key="3" prop="goods.brand" label="品牌" align="center" />
								<el-table-column :key="4" prop="goods.sku_value" label="规格" align="center" width="120" />
								<el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
								<el-table-column :key="6" prop="goods_count" label="采购数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.goods_count == 0?'--':scope.row.goods_count}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="7" prop="count" label="分拨数量" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.distributions_list == null">0</span>
										<span v-if="scope.row.distributions_list != null && scope.row.distributions_list.length >= 1">{{scope.row.distributions_list[0].distribution_count}}</span>
										<span v-if="scope.row.distributions_list != null && scope.row.distributions_list.length < 1">0</span>
									</template>
								</el-table-column>
								<el-table-column :key="8" prop="procure_goods_remark" label="备注" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.validation_data == null">--</div>
										<div v-else>
											<span v-if="scope.row.validation_data.remarks == ''">--</span>
											<span v-if="scope.row.validation_data.remarks != ''">{{scope.row.validation_data.remarks}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="9" prop="procure_goods_remark" label="门店验收状态" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.distributions_list == null || scope.row.distributions_list.length == 0">--</span>
										<template v-if="scope.row.distributions_list != null && scope.row.distributions_list.length != 0">
											<span v-if="scope.row.distributions_list[0].distribution_state < 8">--</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 8">未验收</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 9">部分验收:{{scope.row.distributions_list[0].acceptance_info.paid_count}}</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 10" style="color: red;font-weight: bold;">已验收:{{scope.row.distributions_list[0].acceptance_info.paid_count}}</span>
										</template>
									</template>
								</el-table-column>
								<el-table-column :key="10" prop="procure_goods_remark" label="有效期" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.validation_data.overdue_time_list == null">--</span>
										<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length > 1">多效期</span>
										<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length == 1">{{scope.row.validation_data.overdue_time_list[0].overdue_time == ''?'--':FormatDate(scope.row.validation_data.overdue_time_list[0].overdue_time)}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="11" label="条码状态" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.distributions_list == null || scope.row.distributions_list.length == 0">未打码</span>
										<div v-if="scope.row.distributions_list != null && scope.row.distributions_list.length != 0">
											<span v-if="scope.row.distributions_list[0].distribution_state == 3">未分拨</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 4">部分分拨</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 5">未打码</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 6">部分打码</span>
											<span v-if="scope.row.distributions_list[0].distribution_state > 6">已生成条码</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="15" label="异常" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.distributions_list == null || scope.row.distributions_list.length == 0">--</div>
										<div v-else>
											<div v-if="scope.row.distributions_list[0].acceptance_info == null">--</div>
											<template v-if="scope.row.distributions_list[0].acceptance_info != null">
												<div v-if="scope.row.distributions_list[0].acceptance_info.abnormal_info == null">--</div>
												<template v-if="scope.row.distributions_list[0].acceptance_info.abnormal_info != null">
													<el-popover placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.leakage_count+' 破损:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.broken_count+' 过期:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.overdue_count+' 调换:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.switch_count+' 无货:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.no_count">
														<div slot="reference">异常{{scope.row.distributions_list[0].acceptance_info.abnormal_info.leakage_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.broken_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.overdue_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.switch_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.no_count}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
													</el-popover>
												</template>
											</template>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="12" label="操作" align="center" width="140" >
									<template slot-scope="scope">
										<el-button type="text" size="small" v-if="scope.row.distributions_list != null && scope.row.distributions_list.length != 0 && scope.row.distributions_list[0].distribution_state > 5" @click="toggleOtherClick(scope.row,1,index)">查看条码</el-button>
									</template>
								</el-table-column>
								<!-- 查看条码 -->
								<el-table-column type="expand" width="1">
									<template slot-scope="scope" v-if="scope.row.procure_goods_state > 5">
										<div class="codeView">
											<div v-for="(shopItem,shopIndex) in scope.row.distributions_list" class="shopView" :key="'shopItem'+shopIndex">
												<div v-if="shopItem.code_count != 0">
													<div class="shopViewName">{{shopItem.company_info.shop_name}}</div>
													<div class="validView" v-for="(overItem,overIndex) in shopItem.distribution_datas_list" :key="'overItem'+overIndex">
														<div v-if="overItem.code_count != 0">
															<div class="validViewName">有效期:{{FormatDate(overItem.overdue_time)}} 条码数量:{{overItem.code_count}}</div>
															<template v-for="(codeItem,codeIndex) in overItem.goods_code_list">
																<div v-if="codeItem.goods_state == 4" class="codes1" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)" :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
																<div v-else class="codes" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)" :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
															</template>
														</div>
													</div>
												</div>
											</div>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="allNum">
								<div>申请采购共{{item.procureGoodsList.shop.allCount}}件</div>
								<!-- <div>成本价合计：{{item.procureGoodsList.shop.allPrice.toFixed(2)}}</div> -->
								<!-- <div>分拨共{{item.procureGoodsList.drug.paidcount}}件</div> -->
							</div>
						</div>
					</div>
					<!-- 医疗类 -->
					<div class="shopClass" v-if="item.procureGoodsList.drug.drugs.length > 0 && item.isShow">
						<div class="comH2" @click="handleStoreZLClick(index,2)">
							<div>医疗类</div>
							<i class="el-icon-caret-bottom" v-if="item.procureGoodsList.drug.isShow"></i>
							<i class="el-icon-caret-top" v-else></i>
						</div>
						<div class="tableWarp" v-if="item.procureGoodsList.drug.isShow">
							<el-table :ref="'drugTable'+index" :data="item.procureGoodsList.drug.drugs" tooltip-effect="dark" @selection-change="handleSelectDrug(arguments[0],index)" size="small">
								<el-table-column type="selection" width="55"/>
								<el-table-column :key="1" prop="goods.title" label="商品名称" />
								<el-table-column :key="2" width="50">
									<template slot-scope="scope">
										<el-tag effect="dark" v-if="scope.row.add_type == 2" size="small" type="success">采</el-tag>
									</template>
								</el-table-column>
								<el-table-column :key="3" prop="goods.brand" label="品牌" align="center" />
								<el-table-column :key="4" prop="goods.sku_value" label="规格" align="center" width="120" />
								<el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
								<el-table-column :key="6" prop="goods_count" label="采购数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.goods_count == 0?'--':scope.row.goods_count}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="7" prop="count" label="分拨数量" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.distributions_list == null">0</span>
										<span v-if="scope.row.distributions_list != null && scope.row.distributions_list.length >= 1">{{scope.row.distributions_list[0].distribution_count}}</span>
										<span v-if="scope.row.distributions_list != null && scope.row.distributions_list.length < 1">0</span>
									</template>
								</el-table-column>
								<el-table-column :key="8" prop="procure_goods_remark" label="备注" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.validation_data == null">--</div>
										<div v-else>
											<span v-if="scope.row.validation_data.remarks == ''">--</span>
											<span v-if="scope.row.validation_data.remarks != ''">{{scope.row.validation_data.remarks}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="9" prop="procure_goods_remark" label="门店验收状态" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.distributions_list == null || scope.row.distributions_list.length == 0">--</span>
										<template v-if="scope.row.distributions_list != null && scope.row.distributions_list.length != 0">
											<span v-if="scope.row.distributions_list[0].distribution_state < 8">--</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 8">未验收</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 9">部分验收:{{scope.row.distributions_list[0].acceptance_info.paid_count}}</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 10" style="color: red;font-weight: bold;">已验收:{{scope.row.distributions_list[0].acceptance_info.paid_count}}</span>
										</template>
									</template>
								</el-table-column>
								<el-table-column :key="10" prop="procure_goods_remark" label="有效期" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.validation_data.overdue_time_list == null">--</span>
										<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length > 1">多效期</span>
										<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length == 1">{{scope.row.validation_data.overdue_time_list[0].overdue_time == ''?'--':FormatDate(scope.row.validation_data.overdue_time_list[0].overdue_time)}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="11" label="条码状态" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.distributions_list == null || scope.row.distributions_list.length == 0">未打码</span>
										<div v-if="scope.row.distributions_list != null && scope.row.distributions_list.length != 0">
											<span v-if="scope.row.distributions_list[0].distribution_state == 3">未分拨</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 4">部分分拨</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 5">未打码</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 6">部分打码</span>
											<span v-if="scope.row.distributions_list[0].distribution_state > 6">已生成条码</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="15" label="异常" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.distributions_list == null || scope.row.distributions_list.length == 0">--</div>
										<div v-else>
											<div v-if="scope.row.distributions_list[0].acceptance_info == null">--</div>
											<template v-if="scope.row.distributions_list[0].acceptance_info != null">
												<div v-if="scope.row.distributions_list[0].acceptance_info.abnormal_info == null">--</div>
												<template v-if="scope.row.distributions_list[0].acceptance_info.abnormal_info != null">
													<el-popover placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.leakage_count+' 破损:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.broken_count+' 过期:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.overdue_count+' 调换:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.switch_count+' 无货:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.no_count">
														<div slot="reference">异常{{scope.row.distributions_list[0].acceptance_info.abnormal_info.leakage_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.broken_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.overdue_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.switch_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.no_count}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
													</el-popover>
												</template>
											</template>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="12" label="操作" align="center" width="140">
									<template slot-scope="scope">
										<el-button type="text" size="small" v-if="scope.row.distributions_list != null && scope.row.distributions_list.length != 0 && scope.row.distributions_list[0].distribution_state > 5" @click="toggleOtherClick(scope.row,2,index)">查看条码</el-button>
									</template>
								</el-table-column>
								<!-- 查看条码 -->
								<el-table-column type="expand" width="1">
									<template slot-scope="scope" v-if="scope.row.procure_goods_state > 5">
										<div class="codeView">
											<template v-if="scope.row.distributions_list.length != 0">
												<div v-for="(shopItem,shopIndex) in scope.row.distributions_list" class="shopView" :key="'shopItem'+shopIndex">
													<template v-if="shopItem.distribution_datas_list != undefined">
														<div class="shopViewName">{{shopItem.company_info.shop_name}}</div>
														<div class="validView" v-for="(overItem,overIndex) in shopItem.distribution_datas_list" :key="'overItem'+overIndex">
															<template v-if="overItem.code_count != 0">
																<div class="validViewName">有效期:{{FormatDate(overItem.overdue_time)}} 条码数量:{{overItem.code_count}}</div>
																<template v-for="(codeItem,codeIndex) in overItem.goods_code_list">
																	<div v-if="codeItem.goods_state == 4" class="codes1" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)" :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
																	<div v-else class="codes" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)" :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
																</template>
															</template>
														</div>
													</template>
												</div>
											</template>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="allNum">
								<div>申请采购共{{item.procureGoodsList.drug.allCount}}件</div>
								<!-- <div>成本价合计：{{item.procureGoodsList.drug.allPrice.toFixed(2)}}</div> -->
								<!-- <div>分拨共{{item.procureGoodsList.drug.paidcount}}件</div> -->
							</div>
						</div>
					</div>
					<!-- 耗材类 -->
					<div class="shopClass" v-if="item.procureGoodsList.haocai.haocais.length > 0 && item.isShow">
						<div class="comH2" @click="handleStoreZLClick(index,3)">
							<div>耗材类</div>
							<i class="el-icon-caret-bottom" v-if="item.procureGoodsList.haocai.isShow"></i>
							<i class="el-icon-caret-top" v-else></i>
						</div>
						<div class="tableWarp" v-if="item.procureGoodsList.haocai.isShow">
							<el-table :ref="'haocaiTable'+index" :data="item.procureGoodsList.haocai.haocais" tooltip-effect="dark" @selection-change="handleSelectHaocai(arguments[0],index)" size="small">
								<el-table-column type="selection" width="55"/>
								<el-table-column :key="1" prop="goods.title" label="商品名称" />
								<el-table-column :key="2" width="50">
									<template slot-scope="scope">
										<el-tag effect="dark" v-if="scope.row.add_type == 2" size="small" type="success">采</el-tag>
									</template>
								</el-table-column>
								<el-table-column :key="3" prop="goods.brand" label="品牌" align="center">
									<template>
										<span>--</span>
									</template>
								</el-table-column>
								<el-table-column :key="4" prop="goods.sku_value" label="规格" align="center" width="120">
									<template>
										<span>--</span>
									</template>
								</el-table-column>
								<el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
								<el-table-column :key="6" prop="goods_count" label="采购数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.goods_count == 0?'--':scope.row.goods_count}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="7" prop="count" label="分拨数量" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.distributions_list == null">0</span>
										<span v-if="scope.row.distributions_list != null && scope.row.distributions_list.length >= 1">{{scope.row.distributions_list[0].distribution_count}}</span>
										<span v-if="scope.row.distributions_list != null && scope.row.distributions_list.length < 1">0</span>
									</template>
								</el-table-column>
								<el-table-column :key="8" prop="procure_goods_remark" label="备注" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.validation_data == null">--</div>
										<div v-else>
											<span v-if="scope.row.validation_data.remarks == ''">--</span>
											<span v-if="scope.row.validation_data.remarks != ''">{{scope.row.validation_data.remarks}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="9" prop="procure_goods_remark" label="门店验收状态" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.distributions_list == null || scope.row.distributions_list.length == 0">--</span>
										<template v-if="scope.row.distributions_list != null && scope.row.distributions_list.length != 0">
											<span v-if="scope.row.distributions_list[0].distribution_state < 8">--</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 8">未验收</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 9">部分验收:{{scope.row.distributions_list[0].acceptance_info.paid_count}}</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 10" style="color: red;font-weight: bold;">已验收:{{scope.row.distributions_list[0].acceptance_info.paid_count}}</span>
										</template>
									</template>
								</el-table-column>
								<el-table-column :key="10" prop="procure_goods_remark" label="有效期" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.validation_data.overdue_time_list == null">--</span>
										<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length > 1">多效期</span>
										<span v-if="scope.row.validation_data.overdue_time_list != null && scope.row.validation_data.overdue_time_list.length == 1">{{scope.row.validation_data.overdue_time_list[0].overdue_time == ''?'--':FormatDate(scope.row.validation_data.overdue_time_list[0].overdue_time)}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="11" label="条码状态" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.distributions_list == null || scope.row.distributions_list.length == 0">未打码</span>
										<div v-if="scope.row.distributions_list != null && scope.row.distributions_list.length != 0">
											<span v-if="scope.row.distributions_list[0].distribution_state == 3">未分拨</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 4">部分分拨</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 5">未打码</span>
											<span v-if="scope.row.distributions_list[0].distribution_state == 6">部分打码</span>
											<span v-if="scope.row.distributions_list[0].distribution_state > 6">已生成条码</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="15" label="异常" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.distributions_list == null || scope.row.distributions_list.length == 0">--</div>
										<div v-else>
											<div v-if="scope.row.distributions_list[0].acceptance_info == null">--</div>
											<template v-if="scope.row.distributions_list[0].acceptance_info != null">
												<div v-if="scope.row.distributions_list[0].acceptance_info.abnormal_info == null">--</div>
												<template v-if="scope.row.distributions_list[0].acceptance_info.abnormal_info != null">
													<el-popover placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.leakage_count+' 破损:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.broken_count+' 过期:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.overdue_count+' 调换:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.switch_count+' 无货:'+scope.row.distributions_list[0].acceptance_info.abnormal_info.no_count">
														<div slot="reference">异常{{scope.row.distributions_list[0].acceptance_info.abnormal_info.leakage_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.broken_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.overdue_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.switch_count+scope.row.distributions_list[0].acceptance_info.abnormal_info.no_count}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
													</el-popover>
												</template>
											</template>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="12" label="操作" align="center" width="140">
									<template slot-scope="scope">
										<el-button type="text" size="small" v-if="scope.row.distributions_list != null && scope.row.distributions_list.length != 0 && scope.row.distributions_list[0].distribution_state > 5" @click="toggleOtherClick(scope.row,3,index)">查看条码</el-button>
									</template>
								</el-table-column>
								<!-- 查看条码 -->
								<el-table-column type="expand" width="1">
									<template slot-scope="scope" v-if="scope.row.procure_goods_state > 5">
										<div class="codeView">
											<template v-if="scope.row.distributions_list.length != 0">
												<div v-for="(shopItem,shopIndex) in scope.row.distributions_list" class="shopView" :key="'shopItem'+shopIndex">
													<template v-if="shopItem.distribution_datas_list != undefined">
														<div class="shopViewName">{{shopItem.company_info.shop_name}}</div>
														<div class="validView" v-for="(overItem,overIndex) in shopItem.distribution_datas_list" :key="'overItem'+overIndex">
															<template v-if="overItem.code_count != 0">
																<div class="validViewName">有效期:{{FormatDate(overItem.overdue_time)}} 条码数量:{{overItem.code_count}}</div>
																<template v-for="(codeItem,codeIndex) in overItem.goods_code_list">
																	<div v-if="codeItem.goods_state == 4" class="codes1" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)" :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
																	<div v-else class="codes" :class="codeItem.is_check?'active':''" @click="handleSelectAllpCode(codeItem)" :key="'codeItem'+codeIndex">{{codeItem.code}} 使用次数{{codeItem.totaltimes}}</div>
																</template>
															</template>
														</div>
													</template>
												</div>
											</template>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="allNum">
								<div>申请采购共{{item.procureGoodsList.haocai.allCount}}件</div>
								<!-- <div>成本价合计：{{item.procureGoodsList.drug.allPrice.toFixed(2)}}</div> -->
								<!-- <div>分拨共{{item.procureGoodsList.drug.paidcount}}件</div> -->
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>
		<!-- 底部按钮 -->
		<div class="fix_btn">
			<div class="fix_btn_l">
				<div>备注:</div>
				<el-input type="textarea" :row="2" placeholder="请输入内容" v-model="remarkTextValue" resize="none"></el-input>
			</div>
			<div class="fix_btn_r">
				<div class="selectView">
					<div class="selectViewName">批量修改供应商</div>
					<el-select v-model="allInspection" placeholder="请选择" @change="handleAllInspectionClick" style="width: 130px;" filterable>
						<el-option v-for="item in suppliers" :key="item._id" :label="item.basic_info.name" :value="item._id" />
					</el-select>
				</div>
				<el-button type="success" @click="handlePrintCodeClick">打印条码</el-button>
				<el-button type="warning" @click="handleBuCodeClick(1)">条码补码</el-button>
				<el-button type="warning" @click="handleBuCodeClick(2)">删除条码</el-button>
				<el-button type="warning" @click="dialogAddShop_state=true">添加商品</el-button>
				<el-button type="warning" @click="handleCarryClick">采购完成</el-button>
			</div>
		</div>

		<!-- 添加商品弹框 -->
		<div v-if="dialogAddShop_state">
			<dialogAddShop @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state" @submit="selectShop" :tree.sync="tree"></dialogAddShop>
		</div>
		
		<!-- 验货弹框 -->
		<div v-if="dialogInspection_state">
			<dialogInspection @refresh="handleRefresh" @closeOn="handleInspecClose" :inSpectionState.sync="dialogInspection_state" :id.sync="id" :inspectionData.sync="inspectionData"></dialogInspection>
		</div>
		<!-- 分拨弹框 -->
		<div v-if="dialogAssign_state">
			<dialogAssign @refresh="handleRefreshAssign" @closeOn="handleAssignClose" :assignState.sync="dialogInspection_state" :id.sync="id" :assignData.sync="assignData"></dialogAssign>
		</div>
		<!-- 打码弹框 -->
		<div v-if="dialogPrintCode_state">
			<dialogPrintCode @closeOn="handlePrintCodeClose" :assignState.sync="dialogPrintCode_state" :id.sync="id" :printCodeData.sync="printCodeData"></dialogPrintCode>
		</div>
		<!-- 分拨出库记录 -->
		<div v-if="dialogRecord_state">
			<dialogRecord @closeOn="handleRecordClose" :recordState.sync="dialogRecord_state" :id.sync="id" :recordData.sync="recordData"></dialogRecord>
		</div>
		<!-- 下载报货单或者验货单 -->
		<div v-if="dialogUpload_state">
			<dialogUpload @closeOn="handleUploadClose" :uploadState.sync="dialogUpload_state" :id.sync="id" :uploadData.sync="uploadData" :uploadType.sync="uploadType" :uploadTitle="uploadTitle"></dialogUpload>
		</div>
		<!-- 条码补码弹框 -->
		<div v-if="dialogbuCode_state">
			<dialogBuCode @closeOn="handleBuCodeClose" :buCodeState.sync="dialogbuCode_state" :id.sync="id" :buCodeData.sync="buCodeData" :codeType='codeType'></dialogBuCode>
		</div>
		
		<el-dialog title="修改成本价" :visible.sync="dialogUpdatePriceVisible" width="300px">
			<div style="text-align: center;">
				<el-input-number v-model="updatePrice" :start='0'></el-input-number>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogUpdatePriceVisible = false" size="small">取 消</el-button>
				<el-button type="warning" @click="handleUpdatePriceClick" size="small">确 定</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>
<script>
	import {
		caigouDetail,
		supplierList,
		addProcureGoods,
		// removeProcureGoods,
		moreSupplier,
		returnVerifyn,
		caigouSuccess,
		outbound,
		updateGoodsRemarks
	} from '@/api/purchaseApi.js'
	import caigouFilter from '@/util/caigouFilter.js'
	import dialogAddShop from "../../../components/dialog_addShop.vue"
	import dialogInspection from "../../../components/dialog_Inspection.vue"
	import dialogAssign from "../../../components/dialog_assign.vue"
	import dialogPrintCode from "../../../components/dialog_printcode.vue"
	import dialogRecord from "../../../components/dialog_record.vue"
	import dialogUpload from "../../../components/dialog_upload.vue"
	import dialogBuCode from "../../../components/dialog_buCode.vue"
	import axios from 'axios';
	export default {
		components: {
			dialogAddShop,
			dialogInspection,
			dialogAssign,
			dialogPrintCode,
			dialogRecord,
			dialogUpload,
			dialogBuCode
		},
		data() {
			return {
				codeType:1,  //1是补码  2是删除条码
				shopList: [],
				dialogFormVisible: false,
				textValue: '',
				fixedHeight: '',
				id: this.$route.query.id, //跳转订单id
				detailData: {}, //订单详情
				sqDate: '', //申请时间
				shops: [], //商品类
				drugs: [], //药品类
				haocais: [],  //耗材类
				showShop: true, //显示商品类
				showDrug: true, //显示药品类
				showHaocai: true, //显示耗材类
				showUpadate: true, //显示修改记录
				shopCount: 0,
				shopPrice: 0,
				drugCount: 0,
				drugPrice: 0,
				haocaiCount: 0,
				haocaiPrice: 0,
				dialogAddShop_state: false, //商品弹框状态
				dialogInspection_state: false, //验货弹框状态
				dialogAssign_state: false, //分拨状态
				dialogPrintCode_state:false,  //打印条码状态
				dialogRecord_state:false,  //分拨出库状态
				dialogUpload_state:false,  //下载单弹框
				dialogbuCode_state:false,  //补码弹框
				tabIndex: -1, //tab默认
				storeTab: [], //门店tab切换
				stores:[],  //各个门店列表
				suppliers:[],  //供应商列表
				inspectionData:null, //验货数据
				assignData:null, //分拨数据
				printCodeData:null,  //打码数据
				recordData:null,  //分拨出库数据
				uploadData:null,  //下载单数据
				buCodeData:null, //补码数据
				uploadType:0,  //下载按钮状态
				uploadTitle:'',  //按钮头部
				allInspection:'',  //批量修改供应商
				allSelectShop:[],  //全部选中商品
				allSelectDrug:[],  //全部选中药品
				allSelectHaocai:[],  //全部选中耗材
				endStoreArr:[],  //分拨所选中商品整合
				remarkTextValue:'',  //整体备注
				allCode:[], //全部选中条码
				tree:[{
					id:"602f1e89c904d9db7ccf3c03"
				},{
					id:"602f1e88c904d9db7ccf3bec"
				},{
					id:"6049cf035a0dfcc381f9311a"
				}],
				updatePrice:0,
				dialogUpdatePriceVisible:false,
				priceRow:null,
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
			this.getDetailData()
			this.getSuppliersData(); 
		},
		methods: {
			//修改成本价确认按钮
			handleUpdatePriceClick(){
				let params = {
					procure_no: this.id,
					procure_goods_id: this.priceRow.procure_goods_id,
					cost_price: this.updatePrice
				};
				this.$http.post(process.env.VUE_APP_Url4 + 'api/Procure/UpdateCostPrice',params).then(
					res => {
						if (res.code == 0) {
							this.dialogUpdatePriceVisible = false;
							this.$message({
								type: 'success',
								message: '已修改'
							})
							this.getDetailData()
						}
					})
			},
			//修改成本价
			handleUpdatePrice(row){
				console.log(row)
				this.priceRow = row;
				this.updatePrice = row.validation_data.cost_price;
				this.dialogUpdatePriceVisible = true;
			},
			//下载分拨单
			handleUploadRecordClick(){
				console.log(this.detailData);
				axios.get(process.env.VUE_APP_Url4+'api/Procure/UpLoadDistribution',{
					params:{
						id:this.detailData.procure_no,
					},
					responseType: 'blob'
				}).then(response => {
					// console.log(response)
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '分拨单导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
				}).catch(err => {
						console.log(err)
				})
			},
			// 下载配送单
			handleDeliveryClick(){
				axios.get(process.env.VUE_APP_Url4+'api/Procure/UpLoadDeliver',{
					params:{
						id:this.detailData.procure_no,
					},
					responseType: 'blob'
				}).then(response => {
					console.log(response)
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '配送单导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
				}).catch(err => {
						console.log(err)
				})
			},
			//修改备注
			remarkChange(row){
				console.log(row)
				let pamars = {
					id:this.id,
					procure_goods_id_list:row.procure_goods_id,
					remarks:row.validation_data.remarks,
				}
				console.log(pamars)
				updateGoodsRemarks(pamars).then((res)=>{
					if(res.code == 0){
						this.$message({
							message:'已添加备注',
							type:'success'
						})
					}
				})
			},
			//复制商品
			handleCopyClick(row){
				console.log('复制商品',row)
				let pamars ={
					id:this.id,
					add_procure_goods:{
						goods:{
							_id: row.goods._id,
							title: row.goods.title,
							category_id: row.goods._id,
							category_name: row.goods.name,
							sku_id: row.goods.sku_id,
							sku_value: row.goods.skus_name,
							goods_type: Number(row.goods.goods_type),
							pprice: row.goods.pprice,
							brand:row.goods.brand,
							times:row.goods.times,
							packing_way_id:row.goods.packing_way_id,
							unit:row.goods.unit
						},
						goods_count:0,
						procure_goods_remark:''
					}
				}
				addProcureGoods((pamars)).then((res)=>{
					if(res.code == 0){
						console.log(res)
						this.$message({
							message:'已复制',
							type:'success'
						})
						this.getDetailData();
					}
				})
			},
			//返回按钮
			handleBackClick(){
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({path:'caigouList'})
					let storage = window.sessionStorage
					storage.setItem("cgtabs",1)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});          
				});
			},
			//条码补码按钮
			handleBuCodeClick(type){
				console.log('补码',this.allCode);
				let allCode = [...this.allCode];
				// if(allCode.length == 0){
				// 	this.$message({
				// 		message:'请选择条码',
				// 		type:'warning'
				// 	})
				// 	return
				// }
				this.dialogbuCode_state = true;
				this.codeType = type;
				this.buCodeData = allCode;
			},
			//关闭补码弹框
			handleBuCodeClose(val){
				this.dialogbuCode_state = val.type;
				if(val.data == 'submit'){
					this.getDetailData()
				}
				console.log(val)
			},
			//全部商品选择条码
			handleSelectAllpCode(item){
				console.log(item,"全部选中条码")
				if(this.allCode.length > 0){
					for(let j = 0;j<this.allCode.length;j++){
						if(!item.is_check && item.code == this.allCode[j].code){
							this.$message({
								message:'已选择重复条码',
								type:'info'
							})
							return
						}
					}
				}
				item.is_check = !item.is_check;
				if(item.is_check){
					this.allCode.push(item)
				}
				// console.log(this.allCode)
				for(let i = 0;i< this.allCode.length;i++){
					if(!this.allCode[i].is_check){
						this.allCode.splice(i,1)
					}
				}
				// console.log('全部商品条码',this.allCode)
			},
			//其他门店查看条码按钮
			toggleOtherClick(row,type,index){
				// console.log(row,index)
				if(type == 1){
					// console.log('其他商品',this.$refs)
					
					let $table1 = this.$refs['shopTable'+index][0];
					
					$table1.toggleRowExpansion(row)
				}else if(type == 2){
					// console.log('其他药品',this.$refs)
					let $table2 = this.$refs['drugTable'+index][0];
					
					$table2.toggleRowExpansion(row)
				}else if(type == 3){
					// console.log('其他耗材',this.$refs)
					let $table3 = this.$refs['haocaiTable'+index][0];
					
					$table3.toggleRowExpansion(row)
				}
			},
			//全部药品查看条码
			toggleAllDrug(row){
				let $table = this.$refs.allDrugTable;
				$table.toggleRowExpansion(row)
				// console.log('查看条码',row.distributions_list)
			},
			//全部商品查看条码
			toggleAllShop(row){
				let $table = this.$refs.allShopTable;
				$table.toggleRowExpansion(row)
				// console.log('查看条码',row.distributions_list)
			},
			//全部耗材查看条码
			toggleAllHaocai(row){
				let $table = this.$refs.allHaocaiTable;
				$table.toggleRowExpansion(row)
				// console.log('查看条码',row.distributions_list)
			},
			//分拨出库
			handlefenbochukuClick(index){
				console.log(index,this.stores)
				let stores = [...this.stores];
				let shop_id = stores[index].companyInfo.shop_id;
				this.$confirm('该门店是否分拨出库？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let parmars = {
						id:this.id,
						shop_id:shop_id
					}
					outbound(parmars).then((res)=>{
						if(res.code  == 0){
							this.$message({
								type: 'success',
								message: '已分拨出库'
							});
							this.getDetailData()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '暂不分拨出库'
					});          
				});
			},
			//采购完成
			handleCarryClick(){
				this.$confirm('该采购单是否采购完成', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let parmars = {
						id:this.id,
						remark:this.remarkTextValue
					}
					caigouSuccess(parmars).then((res)=>{
						if(res.code == 0){
							this.$message({
								message:'采购完成',
								type:'success'
							})
							this.$router.push({path:'caigouList'})
							let storage = window.sessionStorage
							storage.setItem("cgtabs",1)
						} 
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '暂不操作'
					});          
				});
			},
			//全部商品选中
			handleAllShopChange(val){
				this.allSelectShop = val;
			},
			//全部药品
			handleAllDrugChange(val){
				this.allSelectDrug = val
			},
			//全部耗材
			handleAllHaocaiChange(val){
				this.allSelectHaocai = val
			},
			//批量修改供应商
			handleAllInspectionClick(){
				console.log(this.allInspection)
				console.log(this.allSelectShop,this.allSelectDrug)
				let arr = this.allSelectShop.concat(this.allSelectDrug).concat(this.allSelectHaocai);
				if(arr.length == 0){
					this.$message({
						message: '请选择需要修改商品',
						type: 'warning'
					});
					return
				}
				console.log(arr)
				//获取label;
				let selectName = this.suppliers.find(val=>val._id==this.allInspection).basic_info.name;
				let idArr = [];
				for(let i = 0;i<arr.length;i++){
					idArr.push(arr[i].procure_goods_id)
				}
				console.log(idArr);
				let parmars = {
					id:this.id,
					procure_goods_id_list:idArr,
					supplier_id:this.allInspection,
					supplier_name:selectName
				}
				moreSupplier(parmars).then((res)=>{
					if(res.code == 0){
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						console.log(res)
						this.allInspection = '';
						this.getDetailData()
					}
				})
				
			},
			//单个修改供应商
			selectDChange(row){
				console.log(row)
				let idArr = [];
				let selectName = this.suppliers.find(val=>val._id==row.supplier_id).basic_info.name;
				console.log(selectName)
				idArr.push(row.procure_goods_id)
				let parmars = {
					id:this.id,
					procure_goods_id_list:idArr,
					supplier_id:row.supplier_id,
					supplier_name:selectName
				}
				moreSupplier(parmars).then((res)=>{
					
					if(res.code == 0){
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						console.log(res)
						this.allInspection = '';
						this.getDetailData()
					}
				})
			},
			//table子项商品
			handleSelectShop(val,index){
				console.log(val,index)
				this.endStoreArr[index].procureGoodsList.shop.shops = val 
				console.log(this.endStoreArr[index])
			}, 
			//table子项医疗
			handleSelectDrug(val,index){
				console.log(val,index)
				this.endStoreArr[index].procureGoodsList.drug.drugs = val 
			}, 
			//table子项耗材
			handleSelectHaocai(val,index){
				console.log(val,index)
				this.endStoreArr[index].procureGoodsList.haocai.haocais = val 
			},
			//重构日期
			FormatDate(item){
				let time = new Date(item*1000) 
				let year = time.getFullYear()
				let month = time.getMonth() + 1<10?'0'+(time.getMonth() + 1):time.getMonth() + 1
				let date = time.getDate()<10?'0'+time.getDate():time.getDate()
				return year+'-'+month+'-'+date
			},
			//刷新列表
			handleRefresh(){
				this.dialogInspection_state = false
				this.getDetailData()
			},
			//刷新列表
			handleRefreshAssign(){
				this.dialogAssign_state = false;
				this.getDetailData()
			},
			//重新验货
			handleResetGoodsClick(row){
				console.log(row)
				let parmars = {
					id:this.id,
					procure_goods_id:row.procure_goods_id
				}
				returnVerifyn(parmars).then((res)=>{
					console.log(res)
					if(res.code == 0){
						this.dialogInspection_state = true
						this.inspectionData = row
					}
				})
			},
			// handleprintClose(val){
			// 	this.dialogPrintCode_state = val
			// },
			
			//关闭打码弹框
			handlePrintCodeClose(val){
				this.dialogPrintCode_state = val;
				this.getDetailData()
			},
			//打码按钮
			handlePrintCodeClick(){
				console.log('打印条码',this.endStoreArr)
				let shops = [];
				let drugs = [];
				let haocais = [];
				console.log(this.endStoreArr)
				for(let i = 0;i<this.endStoreArr.length;i++){
					shops = shops.concat(this.endStoreArr[i].procureGoodsList.shop.shops);
					drugs = drugs.concat(this.endStoreArr[i].procureGoodsList.drug.drugs);
					haocais = haocais.concat(this.endStoreArr[i].procureGoodsList.haocai.haocais);
				}
				console.log(shops.length,drugs.length)
				let count = shops.length + drugs.length + haocais.length
				console.log(count) 
				if(count != 0){
					this.dialogPrintCode_state = true
					this.printCodeData = [...this.endStoreArr];
				}else{
					this.$message({
						message:'请选择商品或者药品',
						type:'warning'
					})
				}
			},
			//关闭分拨弹框
			handleAssignClose(val){
				this.dialogAssign_state = val
			},
			//分拨按钮
			handleAssignClick(row){
				console.log(row)
				this.dialogAssign_state = true
				
				this.assignData = row
			},
			//关闭分拨出库弹框
			handleRecordClose(val){
				this.dialogRecord_state = val
			},
			//下载验货单和下载报货单按钮
			handleUploadClick(type){
				console.log(this.detailData,'this.detailDatathis.detailData');
				if(this.detailData.supplier_list.length == 0){
					this.$message({
						message:'请选择供应商',
						type:'warning'
					})
					return
				}
				if(type == 1){
					this.uploadType = type;
					this.uploadTitle = '下载验货单';
				}else if(type == 2){
					this.uploadType = type
					this.uploadTitle = '下载报货单';
				}
				this.dialogUpload_state = true
				this.uploadData = this.detailData
			},
			//关闭下载
			handleUploadClose(val){
				this.dialogUpload_state = val
			},
			//分拨出库按钮
			handleRecordClick(){
				if(this.detailData.procure_distributions.length == 0){
					this.$message({
						message:'暂无分拨出库记录',
						type:"warning"
					})
					return;
				}
				this.dialogRecord_state = true
				this.recordData = this.detailData
			},
			//关闭验货弹框
			handleInspecClose(val){
				this.dialogInspection_state = val;
				this.getDetailData()
			},
			//验货按钮
			handleInspectionClick(row){
				console.log(row)
				if(row.supplier_id == null){
					this.$message({
						message:'请选择供应商后，再进行验货',
						type:'warning'
					})
					return
				}
				this.dialogInspection_state = true
				this.inspectionData = row
			},
			//分拨前-门店数据
			getStoreStartData() {
				
				let stores = [...this.detailData.procureRequestLinkDatas];
				// console.log('门店信息',stores)
				let arr = [];
				let shops = [];
				let drugs = [];
				let haocais = [];
				if (stores.length != 0) {
					for (let i = 0; i < stores.length; i++) {
						// 获取tab切换
						if (stores[i].companyInfo.shop_id == '5e9412e0b2bfbc089daerr12') {
							arr.push('金水区店')
						} else if (stores[i].companyInfo.shop_id == '5e9412e0b2bfbc089daerr18') {
							arr.push('郑东新区店')
						} else if (stores[i].companyInfo.shop_id == '5e9412e0b2bfbc089daerr17') {
							arr.push('线上旗舰店')
						} else if (stores[i].companyInfo.shop_id == '5e9412e0b2bfbc089daerr14') {
							arr.push('指挥中心店')
						} else if (stores[i].companyInfo.shop_id == '5e9412e0b2bfbc089daerr10') {
							arr.push('驯养中心')
						} else if (stores[i].companyInfo.shop_id == '5e9412e0b2bfbc089daerr11') {
							arr.push('小程序')
						}
						shops = [];
						drugs = [];
						haocais = [];
						// console.log(stores[0].procureGoodsList.length)
						//重组商品列表
						for(let j = 0; j<stores[i].procureGoodsList.length;j++){
							if(stores[i].procureGoodsList[j].goods.goods_type == '0'){
								shops[j] = stores[i].procureGoodsList[j]
							}else if(stores[i].procureGoodsList[j].goods.goods_type == '1'){
								drugs[j] =  stores[i].procureGoodsList[j]
							}else if(stores[i].procureGoodsList[j].goods.goods_type == '7'){
								haocais[j] =  stores[i].procureGoodsList[j]
							}
							shops = shops.filter(item => item);
							drugs = drugs.filter(item => item);
							haocais = haocais.filter(item => item);
						}
						// console.log(shops,drugs)
						stores[i].procureGoodsList = {
							shop:{
								shops:shops,
								isShow:true,
								allPrice:this.getStoreAllData(shops).price,
								allCount:this.getStoreAllData(shops).count,
								// paidcount:this.getStoreAllData(shops).paidcount
							},
							drug:{
								drugs:drugs,
								isShow:true,
								allPrice:this.getStoreAllData(drugs).price,
								allCount:this.getStoreAllData(drugs).count,
								// paidcount:this.getStoreAllData(drugs).paidcount
							},
							haocai:{
								haocais:haocais,
								isShow:true,
								allPrice:this.getStoreAllData(haocais).price,
								allCount:this.getStoreAllData(haocais).count,
								// paidcount:this.getStoreAllData(drugs).paidcount
							}
						}
						//添加显示状态
						stores[i].isShow = true;
						this.stores = stores;
					}
					this.storeTab = arr;
					this.stores = stores;
					console.log('门店数据',this.stores)
				}
			},
			//分拨后门店整合数据
			getStoreEndData(){
				let stores = [...this.detailData.procureRequestLinkDatas];
				console.log(stores)
				let endArr = [];
				for(let i = 0; i<stores.length;i++){
					endArr[i]={};
					endArr[i].isShow = true;
					endArr[i].procureGoodsList = {};
					endArr[i].procureGoodsList.drug = {};
					endArr[i].procureGoodsList.drug.isShow = true;
					endArr[i].procureGoodsList.drug.drugs = [];
					endArr[i].procureGoodsList.shop = {};
					endArr[i].procureGoodsList.shop.isShow = true;
					endArr[i].procureGoodsList.shop.shops = [];
					endArr[i].procureGoodsList.haocai = {};
					endArr[i].procureGoodsList.haocai.isShow = true;
					endArr[i].procureGoodsList.haocai.haocais = []
					endArr[i].companyInfo= stores[i].companyInfo
				}
				this.endStoreArr = [...endArr]
				console.log('分拨后整合',endArr)
			},
			//获取门店合计
			getStoreAllData(arr){
				// console.log('门店合计',arr)
				let price = 0;
				let count = 0;
				for(let k =0; k<arr.length;k++){
					
					price = (price + (arr[k].goods_count * Number(arr[k].validation_data.cost_price)));
					count = (count +arr[k].goods_count)
				}
				let obj = {
					price:price,
					count:count,
				}
				return obj
			},
			//显示或者隐藏对应门店
			handleStoreClick(index){
				let stores = this.stores;
				stores[index].isShow = !stores[index].isShow;
				this.stores = stores
				this.$set(this.stores,index,this.stores[index])
				console.log(stores)
			},
			//显示或者隐藏对应门店的子类
			handleStoreZLClick(index,type){
				let stores = this.stores;
				console.log(index,type,stores[index])
				if(type == 1){
					stores[index].procureGoodsList.shop.isShow = !stores[index].procureGoodsList.shop.isShow;
				}else if(type == 2){
					stores[index].procureGoodsList.drug.isShow = !stores[index].procureGoodsList.drug.isShow;
				}else if(type == 3){
					stores[index].procureGoodsList.haocai.isShow = !stores[index].procureGoodsList.haocai.isShow;
				}
				this.stores = stores
				this.$set(this.stores,index,this.stores[index])
			},
			//tab切换
			handleTabClick(index) {
				console.log(index)
				this.tabIndex = index;
				let PageId = document.querySelector('#page' + index);
				let indexPageTop = document.querySelector('#page-1').offsetTop;
				// console.log(PageId.offsetTop)
				this.$refs['scrollView'].scrollTo({
					'top': PageId.offsetTop - indexPageTop,
					'behavior': 'smooth'
				})
			},
			//添加商品
			handleAddgoodsClick() {
				this.dialogAddShop_state = true
				this.addGoodsType = false
			},
			//添加商品组件选择事件
			selectShop(row) {
				console.log(row)
				let shops = this.shops;
				let drugs = this.drugs;
				let haocais = this.haocais;
				if (row.goodsType == 1) {
					console.log('选取药品')
					if (drugs != undefined) {
						console.log(drugs)
						console.log('添加新药品')
						let parmars = {
							id: this.id,
							add_procure_goods: {
								goods: {
									_id: row.goodsItem.medical_id,
									title: row.goodsItem.title,
									category_id: row.goodsItem.category_info._id,
									category_name: row.goodsItem.category_info.name,
									sku_id:	'',
									sku_value: row.goodsItem.old_packinfo_info.sku_value,
									goods_type: 1,
									pprice: row.goodsItem.pprice,
									brand:row.goodsItem.brand_name,
									times:row.goodsItem.medical_ext_info.use_times,
									packing_way_id:'',
									unit:row.goodsItem.old_packinfo_info.unit
								},
								goods_count: 0,
								procure_goods_remark: "",
							}
						}
						console.log(parmars)
						addProcureGoods(parmars).then((res) => {
							if (res.code == 0) {
								this.$message({
									message: '新增药品',
									type: 'success'
								})
								this.getDetailData()
							}
						})
					}
				} else if (row.goodsType == 0) {
					console.log('选取商品')
					if (shops != undefined) {
						if (!this.addGoodsType) {
							console.log('添加新商品')
							let parmars = {
								id: this.id,
								add_procure_goods: {
									goods: {
										_id: row.goodsItem.goodsId,
										title: row.goodsItem.title,
										category_id: row.goodsItem.category_info._id,
										category_name: row.goodsItem.category_info.name,
										sku_id: row.skuItem._id,
										sku_value: row.skuItem.skus_name,
										goods_type: 0,
										pprice: row.wayItem.pprice,
										brand:row.goodsItem.brand_name,
										times:1,
										packing_way_id:row.wayItem.packing_way_id,
										unit:row.wayItem.packing_way_name
									},
									goods_count: 0,
									procure_goods_remark: "",
								}
							}
							console.log(parmars)
							addProcureGoods(parmars).then((res) => {
								if (res.code == 0) {
									this.$message({
										message: '新增商品',
										type: 'success'
									})
									this.getDetailData()
								}
							})
						}
					}
				}else if (row.goodsType == 7) {
					console.log('选取耗材')
					if (haocais != undefined) {
						if (!this.addGoodsType) {
							console.log('添加新耗材')
							let parmars = {
								id: this.id,
								add_procure_goods: {
									goods: {
										_id: row.goodsItem.consumablematerial_id,
										title: row.goodsItem.title,
										category_id: row.goodsItem.category_info._id,
										category_name: row.goodsItem.category_info.name,
										sku_id: '',
										sku_value: '',
										goods_type: 7,
										pprice: 0,
										brand:'',
										times:row.skuItem.use_times,
										packing_way_id:'',
										unit:row.goodsItem.packing_unit
									},
									goods_count: 0,
									procure_goods_remark: "",
								}
							}
							console.log(parmars)
							addProcureGoods(parmars).then((res) => {
								if (res.code == 0) {
									this.$message({
										message: '新增耗材',
										type: 'success'
									})
									this.getDetailData()
								}
							})
						}
					}
				}
			},
			// 删除按钮
			handleDeleteClick(row) {
				this.$confirm('确认要删除这条信息吗?', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(row.procure_goods_id, this.id)
					let params = {
						procure_no: this.id,
						procure_goods_id: row.procure_goods_id
					};
					this.$http.post(process.env.VUE_APP_Url4 + 'api/Procure/RemoveGoods',params).then(
						res => {
							if (res.code == 0) {
								this.$message({
									type: 'warning',
									message: '已删除'
								})
								this.getDetailData()
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
			},
			//获取采购
			getSuppliersData(){
				supplierList().then((res)=>{
					if(res.code == 0){
						// console.log('供应商列表111',res.data);
						this.suppliers = res.data.data;
					}
				})
			},
			//获取详情
			getDetailData() {
				let parmars = {
					id: this.id
				}
				caigouDetail(parmars).then((res) => {
					if (res.code == 0) {
						console.log('商品详情', res.data)
						this.detailData = res.data;
						let detail = res.data;
						let shopList = []; //商品列表
						let drugList = []; //药品列表
						let haocaiList = [];  //耗材列表
						if(detail.procure_goods_list.length != 0){
							this.getStoreStartData(); //获取门店信息
							this.getStoreEndData();  //分拨后门店数据整合
							for (let i = 0; i < detail.procure_goods_list.length; i++) {
								if (detail.procure_goods_list[i].goods.goods_type == 0) {
									shopList[i] = detail.procure_goods_list[i]
								} else if (detail.procure_goods_list[i].goods.goods_type == 1) {
									drugList[i] = detail.procure_goods_list[i]
								}else if (detail.procure_goods_list[i].goods.goods_type == 7) {
									haocaiList[i] = detail.procure_goods_list[i]
								}
								this.sqDate = caigouFilter.timestampToTime(detail.add_info.create_time)
								this.shops = shopList.filter(item => item);
								this.drugs = drugList.filter(item => item);
								this.haocais = haocaiList.filter(item => item);
								this.getAllData()
							}
						}else{
							this.shops = [];
							this.drugs = [];
							this.haocais = [];
							this.endStoreArr = [];
							this.storeTab = [];
							this.stores = [];
						}
						
					}
				})
			},
			// 获取总合计
			getAllData() {
				// console.log('商品列表', this.shops)
				// console.log('药品列表', this.drugs)
				let shops = this.shops;
				let drugs = this.drugs;
				let haocais = this.haocais;
				let shopCount = 0;
				let shopPrice = 0;
				let drugCount = 0;
				let drugPrice = 0;
				let haocaiCount = 0;
				let haocaiPrice = 0;
				if (shops.length > 0) {
					for (let i = 0; i < shops.length; i++) {
						// console.log(shops[i].goods_count)
						shopCount = (shopCount + shops[i].goods_count);
						shopPrice = (shopPrice + shops[i].goods_count * Number(shops[i].validation_data.cost_price))
					}
					this.shopCount = shopCount;
					this.shopPrice = shopPrice;
				}
				if (drugs.length > 0) {
					for (let j = 0; j < drugs.length; j++) {
						drugCount = (drugCount + drugs[j].goods_count);
						drugPrice = (drugPrice + drugs[j].goods_count * drugs[j].validation_data.cost_price)
					}
					this.drugCount = drugCount;
					this.drugPrice = drugPrice
				}
				if (haocais.length > 0) {
					for (let k = 0; k < haocais.length; k++) {
						haocaiCount = (haocaiCount + haocais[k].goods_count);
						haocaiPrice = (haocaiPrice + haocais[k].goods_count * haocais[k].validation_data.cost_price)
					}
					this.haocaiCount = haocaiCount;
					this.haocaiPrice = haocaiPrice
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	.page {
		display: flex;
		flex-direction: column;
		// 重复头部
		.titleView {
			// width: 98%;
			width: 99%;
			padding: 20px 0;
			// padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}

		.scrollView {
			flex: 1;
			.storeName{
				font-size: 20px;
				color: #1890FF;
				line-height: 64px;
				font-weight: bold;
				display: flex;
				justify-content: space-between;
				align-items: center;
				div:nth-of-type(1){
					margin-left: 20px;
				}
			}
			.codeView{
				background: #EBF4FF;
				color: #3C3C3C;
				overflow: hidden;
				padding: 10px;
				.shopViewName{
					font-size: 18px;
					line-height: 32px;
				}
				.validView{
					overflow: hidden;
					.validViewName{
						font-size: 16px;
						line-height: 30px;
					}
					.active{
						background: #18A44C !important;
						color: #fff !important;
					}
					.codes{
						padding: 0 5px;
						font-size: 14px;
						border: solid 1px #e9e9eb;
						background: #f4f4f5;
						color: #909399;
						line-height: 22px;
						float: left;
						margin-right: 14px;
						margin-bottom: 6px;
					}
					.codes1{
						padding: 0 5px;
						font-size: 14px;
						border: solid 1px #e9e9eb;
						background: #f4f4f5;
						color: #6CDA35;
						line-height: 22px;
						float: left;
						margin-right: 14px;
						margin-bottom: 6px;
					}
				}
			}
		}

		//重复标题
		.comH2 {
			line-height: 64px;
			font-size: 18px;
			display: flex;
			align-items: center;
		}

		.comH2 div {
			margin-left: 20px;
			margin-right: 6px;
			font-weight: bold;
		}

		.comH2 img {
			width: 16px;
			height: 16px;
			background: red;
		}

		.tableWarp {
			border-radius: 6px;
			background: #fff;
			padding: 20px 30px;

			.tableName {
				line-height: 46px;
				background: #F7F6F9;
				font-size: 18px;
				color: #2A2A2A;
				font-weight: bold;
				margin-bottom: 10px;
			}

			.allNum {
				font-size: 14px;
				background: #F5F5F5;
				height: 50px;
				display: flex;
				align-items: center;
				padding-left: 20px;

				div:nth-of-type(1) {
					margin-right: 20px;
				}
			}
		}

		.fix_btn {
			width: 100%;
			height: 72px;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: space-between;
			align-items: center;
			.fix_btn_l{
				margin-left: 20px;
				display: flex;
				align-items: center;
				div:nth-of-type(1){
					width: 60px;
				}
			}
			.fix_btn_r{
				display: flex;
				align-items: center;
				button {
					margin-right: 10px;
				}
				
				button:nth-of-type(5) {
					margin-right: 60px;
				}
				.selectView{
					display: flex;
					align-items: center;
					margin-right: 20px;
					.selectViewName{
						margin-right: 10px;
					}
				}
			}
			
		}

		.tabs {
			margin-top: 10px;
			padding: 10px 0;
			background: #fff;

			button {
				margin-left: 20px;
			}
		}
	}
</style>
